// extracted by mini-css-extract-plugin
export default {"rating":"fA-z","numberOfStars":"gA-z","count":"hA-z","barGraphSpacing":"iA-z","barGraph":"jA-z"};